import { Box, Spacer } from "@chakra-ui/react";


export default function About(){
    return (
        <Box>
            <Spacer h={"150px"}/>
            About
        </Box>
    )
}